/********************************************************************************
 * Copyright (c) 2020 Cedalo AG
 *
 * This program and the accompanying materials are made available under the 
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const logger = store => next => (action) => {
	window.DLDEBUG = window.DLDEBUG || localStorage.getItem('DLDEBUG');
	if (window.DLDEBUG) {
		console.log({
			actionType: action && action.type,
			action,
			state: store.getState(),
		});
	}
	if (action) {
		next(action);
	}
};

export default logger;



// WEBPACK FOOTER //
// ./src/helper/LoggerMiddleware.js